import type { AppContext } from '@application/context/AppContext';
import { onActiveTenantChanged, resolveActiveTenantId } from '@application/licence/ActiveTenant';
import { CoffreFortStorageService } from '@application/persistence/CoffreFortStorageService';
import { NetworkStatusService } from '@infra/network/NetworkStatusService';
import { getSyncCoordinator } from '@infra/sync/SyncCoordinator';

/**
 * Rejeu de la file de synchronisation (Cloud via poste) pour l'entreprise ACTIVE au moment
 * de l'événement : retour réseau ou bascule d'entreprise. Aucun tenant capturé au démarrage.
 */
export function bindSyncReplayToActiveTenant(ctx: AppContext): () => void {
  const replay = (): void => {
    const tenantId = resolveActiveTenantId(ctx);
    if (!tenantId) return;
    void getSyncCoordinator().syncWhenOnline(tenantId);
    void CoffreFortStorageService.syncPendingUploads(ctx, tenantId);
  };
  const stopNetwork = NetworkStatusService.subscribe((online) => {
    if (online) replay();
  });
  const stopSwitch = onActiveTenantChanged(() => {
    if (NetworkStatusService.isBrowserOnline()) replay();
  });
  return () => {
    stopNetwork();
    stopSwitch();
  };
}
